(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["haloral-results-showcase"] && !Shopify.designMode) return;
  try {
    
(() => {
  const elementName = 'haloral-results-showcase';
  if (customElements.get(elementName)) return;

  class HaloralResultsShowcase extends HTMLElement {
    connectedCallback() {
      if (this.frame || this.events) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        if (this.isConnected) this.initialize();
      });
    }

    initialize() {
      this.imageElement = this.querySelector('[data-images]');
      this.copyElement = this.querySelector('[data-copy]');
      this.thumbElement = this.querySelector('[data-thumbnails]');
      this.imageTrack = this.imageElement?.querySelector(':scope > .hsc__track');
      this.copyTrack = this.copyElement?.querySelector(':scope > .hsc__track');
      this.copySlides = Array.from(this.querySelectorAll('[data-copy-slide]'));
      if (!this.imageElement || !this.imageTrack || !this.copyElement || !this.copyTrack || !this.copySlides.length) return;

      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.thumbnails = Array.from(this.querySelectorAll('[data-thumbnail]'));
      this.imageSlides = Array.from(this.querySelectorAll('[data-image-slide]'));
      this.index = Math.max(0, this.copySlides.findIndex(slide => slide.getAttribute('aria-hidden') === 'false'));
      this.events = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion:reduce)');
      this.swipeEnabled = this.dataset.swipe === 'true';
      this.drag = null;
      this.suppressClick = false;

      /* Small state objects keep instance behavior explicit and dependency-free. */
      this.images = { activeIndex: this.index, params: { allowTouchMove: this.swipeEnabled } };
      this.copy = { activeIndex: this.index };
      this.thumbs = { params: { direction: 'horizontal' }, translate: 0 };

      this.setAttribute('data-ready', '');
      this.bindEvents();
      this.select(this.index, 'initial', 0);

      this.layoutObserver = new ResizeObserver(() => this.updateLayout());
      this.layoutObserver.observe(this.imageElement);
      this.layoutObserver.observe(this.copyElement);
    }

    bindEvents() {
      const signal = this.events.signal;

      this.addEventListener('click', event => {
        if (this.suppressClick) {
          this.suppressClick = false;
          event.preventDefault();
          return;
        }
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.matches('[data-tab], [data-thumbnail]')) this.select(Number(button.dataset.index));
        if (button.matches('[data-prev]')) this.select(this.index - 1);
        if (button.matches('[data-next]')) this.select(this.index + 1);
      }, { signal });

      this.addEventListener('keydown', event => {
        const control = event.target.closest('[data-tab], [data-thumbnail], [data-images]');
        const verticalThumb = control?.matches('[data-thumbnail]') && matchMedia('(min-width:990px)').matches;
        const keys = verticalThumb
          ? ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End']
          : ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (!control || !keys.includes(event.key)) return;
        event.preventDefault();
        const index = event.key === 'Home'
          ? 0
          : event.key === 'End'
            ? this.copySlides.length - 1
            : this.index + (event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1);
        this.select(index);
        if (control.matches('[data-tab]')) this.tabs[this.index]?.focus({ preventScroll: true });
        if (control.matches('[data-thumbnail]')) this.thumbnails[this.index]?.focus({ preventScroll: true });
      }, { signal });

      this.addEventListener('shopify:block:select', event => {
        const index = this.copySlides.findIndex(slide => slide.dataset.blockId === String(event.detail?.blockId));
        if (index >= 0) this.select(index, 'editor', 0);
      }, { signal });

      this.motion.addEventListener('change', () => this.select(this.index, 'motion', 0), { signal });
      this.thumbElement?.addEventListener('scroll', () => {
        this.thumbs.translate = -(matchMedia('(min-width:990px)').matches
          ? this.thumbElement.scrollTop
          : this.thumbElement.scrollLeft);
      }, { signal, passive: true });

      if (this.swipeEnabled) {
        this.bindImageDrag(signal);
        this.bindTabSwipe(signal);
      }
    }

    select(index, source = 'controls', duration) {
      const numericIndex = Number(index);
      if (!Number.isFinite(numericIndex) || !this.copySlides.length) return;
      const next = Math.max(0, Math.min(this.copySlides.length - 1, Math.round(numericIndex)));
      const speed = duration ?? (this.motion.matches ? 0 : 320);

      this.index = next;
      this.images.activeIndex = next;
      this.copy.activeIndex = next;
      this.applyTrackPosition(next, speed);

      this.tabs.forEach((button, i) => {
        button.setAttribute('aria-selected', String(i === next));
        button.tabIndex = i === next ? 0 : -1;
      });
      this.thumbnails.forEach((button, i) => button.setAttribute('aria-pressed', String(i === next)));
      this.imageSlides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== next)));
      this.copySlides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', String(i !== next));
        slide.hidden = i !== next;
        slide.toggleAttribute('inert', i !== next);
      });

      const previous = this.querySelector('[data-prev]');
      const following = this.querySelector('[data-next]');
      if (previous) previous.disabled = next === 0;
      if (following) following.disabled = next === this.copySlides.length - 1;

      this.revealControl(this.tabs[next]?.parentElement, this.tabs[next], speed);
      this.revealControl(this.thumbElement, this.thumbnails[next], speed);
      requestAnimationFrame(() => this.updateLayout());
    }

    applyTrackPosition(index, speed, dragOffset = 0) {
      const duration = Math.max(0, Number(speed) || 0);
      const transform = dragOffset
        ? `translate3d(calc(${-index * 100}% + ${dragOffset}px), 0, 0)`
        : `translate3d(${-index * 100}%, 0, 0)`;
      this.imageTrack.style.transitionDuration = `${duration}ms`;
      this.imageTrack.style.transform = transform;
    }

    updateLayout() {
      if (!this.copyTrack) return;
      this.copyTrack.style.removeProperty('height');
      this.thumbs.params.direction = matchMedia('(min-width:990px)').matches ? 'vertical' : 'horizontal';
      this.revealControl(this.thumbElement, this.thumbnails[this.index], 0);
    }

    revealControl(scroller, control, speed) {
      if (!scroller || !control) return;
      const vertical = scroller === this.thumbElement && matchMedia('(min-width:990px)').matches;
      const viewportSize = vertical ? scroller.clientHeight : scroller.clientWidth;
      const contentSize = vertical ? scroller.scrollHeight : scroller.scrollWidth;
      if (contentSize <= viewportSize) return;
      const current = vertical ? scroller.scrollTop : scroller.scrollLeft;
      const viewport = scroller.getBoundingClientRect();
      const item = control.getBoundingClientRect();
      const start = current + (vertical ? item.top - viewport.top : item.left - viewport.left);
      const end = start + (vertical ? item.height : item.width);
      let target = current;
      if (start < current) target = start;
      else if (end > current + viewportSize) target = end - viewportSize;
      if (target !== current) scroller.scrollTo({ [vertical ? 'top' : 'left']: target, behavior: speed ? 'smooth' : 'auto' });
    }

    bindImageDrag(signal) {
      const surface = this.imageElement;

      surface.addEventListener('pointerdown', event => {
        if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
        this.drag = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          dx: 0,
          axis: null
        };
        surface.setPointerCapture?.(event.pointerId);
      }, { signal });

      surface.addEventListener('pointermove', event => {
        const drag = this.drag;
        if (!drag || drag.pointerId !== event.pointerId) return;
        const dx = event.clientX - drag.startX;
        const dy = event.clientY - drag.startY;
        if (!drag.axis && Math.hypot(dx, dy) >= 8) drag.axis = Math.abs(dx) > Math.abs(dy) * 1.15 ? 'x' : 'y';
        if (drag.axis !== 'x') return;

        event.preventDefault();
        drag.dx = dx;
        const atEdge = (this.index === 0 && dx > 0) || (this.index === this.copySlides.length - 1 && dx < 0);
        const offset = atEdge ? dx * 0.24 : dx;
        this.setAttribute('data-dragging', '');
        this.applyTrackPosition(this.index, 0, offset);
      }, { signal });

      const finish = event => {
        const drag = this.drag;
        if (!drag || (event.pointerId != null && drag.pointerId !== event.pointerId)) return;
        this.drag = null;
        this.removeAttribute('data-dragging');
        if (drag.axis === 'x') {
          this.suppressClick = Math.abs(drag.dx) > 8;
          const threshold = Math.min(72, surface.clientWidth * 0.16);
          this.select(this.index + (Math.abs(drag.dx) >= threshold ? (drag.dx < 0 ? 1 : -1) : 0));
        } else {
          this.applyTrackPosition(this.index, 0);
        }
      };

      surface.addEventListener('pointerup', finish, { signal });
      surface.addEventListener('pointercancel', finish, { signal });
      surface.addEventListener('lostpointercapture', finish, { signal });
      surface.addEventListener('dragstart', event => event.preventDefault(), { signal });
    }

    bindTabSwipe(signal) {
      const row = this.querySelector('[data-tabs]');
      if (!row) return;
      let touch = null;

      row.addEventListener('touchstart', event => {
        const point = event.touches.length === 1 ? event.touches[0] : null;
        touch = point ? { x: point.clientX, y: point.clientY, index: this.index } : null;
      }, { signal, passive: true });

      row.addEventListener('touchend', event => {
        const start = touch;
        touch = null;
        const point = event.changedTouches[0];
        if (!start || !point) return;
        const dx = point.clientX - start.x;
        const dy = point.clientY - start.y;
        if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          this.select(start.index + (dx < 0 ? 1 : -1));
        }
      }, { signal, passive: true });

      row.addEventListener('touchcancel', () => { touch = null; }, { signal, passive: true });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.events?.abort();
      this.events = null;
      this.layoutObserver?.disconnect();
      this.layoutObserver = null;
      this.drag = null;
      this.removeAttribute('data-ready');
      this.removeAttribute('data-dragging');
    }
  }

  customElements.define(elementName, HaloralResultsShowcase);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haloral-rlt-slider"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag = 'haloral-rlt-slider-v6';
  if (customElements.get(tag)) return;

  class HaloralRltSliderV6 extends HTMLElement {
    connectedCallback() {
      if (this._abort || this._waiting) return;
      if (document.readyState === 'loading') {
        this._waiting = () => {
          this._waiting = null;
          if (this.isConnected) this.init();
        };
        document.addEventListener('DOMContentLoaded',this._waiting,{ once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (this._abort) return;
      this.panels = [...this.querySelectorAll('[data-panel]')];
      if (!this.panels.length) return;

      this.labels = [...this.querySelectorAll('[data-range-label]')];
      this.marks = [...this.querySelectorAll('[data-range-mark]')];
      this.slider = this.querySelector('[data-slider-surface]');
      this.tabList = this.querySelector('[data-tab-list]');
      this.labelsArea = this.querySelector('.hrs-range-labels');
      this.titleNodes = this.labels.map(label => label.querySelector('.hrs-nav-title')).filter(Boolean);
      this.subtitleNodes = this.labels.map(label => label.querySelector('.hrs-nav-subtitle')).filter(Boolean);
      this.labelTexts = this.labels.map(label => label.textContent.replace(/\s+/g,' ').trim());
      this.panelArea = this.querySelector('[data-panels]');
      this._abort = new AbortController();
      this.index = Math.max(0,this.panels.findIndex(panel => panel.hasAttribute('data-active')));
      this.pointerId = null;
      this.sliderPointerId = null;
      this.sliderGrabOffset = 0;
      this.dragAxis = null;
      this._measureFrame = 0;
      this.indicatorPositions = null;
      this.sliderValue = this.index;

      if (this.slider) {
        this.on(this.slider,'pointerdown',event => this.sliderPointerDown(event));
        this.on(this.slider,'pointermove',event => this.sliderPointerMove(event));
        this.on(this.slider,'pointerup',event => this.sliderPointerEnd(event));
        this.on(this.slider,'pointercancel',event => this.sliderPointerEnd(event,true));
        this.on(this.slider,'lostpointercapture',event => {
          if (event.target === this.slider) this.sliderPointerEnd(event,true);
        });
      }

      this.on(this,'click',event => {
        const label = event.target.closest('[data-range-label]');
        if (label && this.contains(label)) this.select(Number(label.dataset.index),true);
      });

      this.on(this,'keydown',event => {
        const label = event.target.closest('[data-range-label]');
        const slider = event.target.closest('[data-slider-surface]');
        if (!label && !slider) return;
        let index = label ? Number(label.dataset.index) : this.index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') index += 1;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') index -= 1;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.panels.length - 1;
        else return;
        event.preventDefault();
        index = Math.max(0,Math.min(this.panels.length - 1,index));
        this.select(index,true);
        if (label && this.labels[index]) this.labels[index].focus({ preventScroll: true });
      });

      if (this.panelArea && this.panels.length > 1) {
        this.on(this.panelArea,'pointerdown',event => this.pointerDown(event));
        this.on(this.panelArea,'pointermove',event => this.pointerMove(event));
        this.on(this.panelArea,'pointerup',event => this.pointerEnd(event));
        this.on(this.panelArea,'pointercancel',event => this.pointerEnd(event,true));
        this.on(this.panelArea,'lostpointercapture',event => {
          if (event.target === this.panelArea) this.pointerEnd(event,true);
        });
        this.on(this.panelArea,'dragstart',event => event.preventDefault());
      }

      this.on(this,'shopify:block:select',event => {
        const index = this.panels.findIndex(panel => panel.dataset.blockId === String(event.detail.blockId));
        if (index >= 0) this.select(index,false);
      });

      this.render(false);
      this.measureNavigation();
      this.setAttribute('data-ready','');
      if (typeof ResizeObserver !== 'undefined') {
        this._resize = new ResizeObserver(() => this.scheduleNavigationMeasure());
        this.labels.forEach(label => this._resize.observe(label));
        const navigation = this.tabList || this.querySelector('.hrs-control');
        if (navigation) this._resize.observe(navigation);
      }
      this.on(window,'resize',() => this.scheduleNavigationMeasure());
      if (document.fonts) this.on(document.fonts,'loadingdone',() => this.scheduleNavigationMeasure());
    }

    on(target,type,callback) {
      target.addEventListener(type,callback,{ signal: this._abort.signal });
    }

    sliderPointerDown(event) {
      if (event.button !== undefined && event.button !== 0) return;
      if (event.isPrimary === false || this.sliderPointerId !== null) return;
      event.preventDefault();
      this.sliderPointerId = event.pointerId;
      const thumb = this.querySelector('.hrs-slider-thumb').getBoundingClientRect();
      const center = thumb.left + thumb.width / 2;
      this.sliderGrabOffset = Math.abs(event.clientX - center) <= thumb.width / 2 + 6 ? event.clientX - center : 0;
      this.slider.setPointerCapture?.(event.pointerId);
      this.slider.setAttribute('data-dragging','');
      this.updateSliderFromPointer(event.clientX);
    }

    sliderPointerMove(event) {
      if (event.pointerId !== this.sliderPointerId) return;
      event.preventDefault();
      this.updateSliderFromPointer(event.clientX);
    }

    sliderPointerEnd(event,cancelled = false) {
      if (event.pointerId !== this.sliderPointerId) return;
      event.preventDefault();
      if (!cancelled) this.updateSliderFromPointer(event.clientX);
      this.sliderPointerId = null;
      this.sliderGrabOffset = 0;
      if (this.slider.hasPointerCapture?.(event.pointerId)) this.slider.releasePointerCapture(event.pointerId);
      this.slider.removeAttribute('data-dragging');
      this.select(Math.round(this.sliderValue),!cancelled);
    }

    updateSliderFromPointer(clientX) {
      if (!this.slider || this.panels.length < 2) return;
      const rect = this.slider.getBoundingClientRect();
      if (!rect.width) return;
      const percent = Math.max(0,Math.min(1,(clientX - (this.sliderGrabOffset || 0) - rect.left) / rect.width));
      const value = percent * (this.panels.length - 1);
      const nearest = Math.round(value);
      this.sliderValue = value;

      if (nearest !== this.index) {
        this.index = nearest;
        this.render(false,true);
      }
      this.updateSlider(value);
    }

    updateSlider(value) {
      if (!this.slider) return;
      const percent = this.panels.length > 1 ? value / (this.panels.length - 1) * 100 : 0;
      this.style.setProperty('--hrs-range-percent',percent + '%');
      this.marks.forEach((mark,index) => mark.toggleAttribute('data-passed',index <= value + .001));
      this.slider.setAttribute('aria-valuenow',String(this.index));
      if (this.labelTexts[this.index]) this.slider.setAttribute('aria-valuetext',this.labelTexts[this.index]);
    }

    pointerDown(event) {
      if (event.button !== undefined && event.button !== 0) return;
      if (event.isPrimary === false || this.pointerId !== null) return;
      if (event.target.closest('a,button,input,select,textarea,video,audio,[contenteditable]')) return;
      this.pointerId = event.pointerId;
      this.dragAxis = null;
      this.startX = event.clientX;
      this.startY = event.clientY;
      this.lastX = event.clientX;
    }

    pointerMove(event) {
      if (event.pointerId !== this.pointerId) return;
      const dx = event.clientX - this.startX;
      const dy = event.clientY - this.startY;
      if (!this.dragAxis && Math.max(Math.abs(dx),Math.abs(dy)) > 8) {
        this.dragAxis = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'x' : 'y';
        if (this.dragAxis === 'x') this.panelArea.setPointerCapture?.(event.pointerId);
      }
      if (this.dragAxis !== 'x') return;
      event.preventDefault();
      this.lastX = event.clientX;
    }

    pointerEnd(event,cancelled = false) {
      if (event.pointerId !== this.pointerId) return;
      const dx = this.lastX - this.startX;
      const horizontal = this.dragAxis === 'x';
      this.pointerId = null;
      this.dragAxis = null;
      if (this.panelArea.hasPointerCapture?.(event.pointerId)) this.panelArea.releasePointerCapture(event.pointerId);
      if (!cancelled && horizontal && Math.abs(dx) > Math.min(72,this.panelArea.clientWidth * .12)) {
        this.select(this.index + (dx < 0 ? 1 : -1),true);
      }
    }

    select(value,scrollLabel) {
      if (!Number.isFinite(value)) return;
      this.index = Math.max(0,Math.min(this.panels.length - 1,Math.round(value)));
      this.sliderValue = this.index;
      this.render(scrollLabel,false);
    }

    render(scrollLabel,preserveThumb) {
      const activePanel = this.panels[this.index];
      this.style.setProperty('--hrs-accent',activePanel.dataset.accent || '#C7594C');

      this.panels.forEach((panel,index) => {
        const active = index === this.index;
        panel.toggleAttribute('data-active',active);
        panel.setAttribute('aria-hidden',String(!active));
        panel.toggleAttribute('inert',!active);
      });

      this.labels.forEach((label,index) => {
        const active = index === this.index;
        label.setAttribute('aria-selected',String(active));
        label.tabIndex = active ? 0 : -1;
      });

      if (!preserveThumb) this.updateSlider(this.index);
      this.updateTabIndicator();

      if (scrollLabel && this.labels[this.index]) {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const scroller = this.labels[this.index].closest('.hrs-control-scroll,.hrs-tabs-scroll');
        if (scroller) {
          const labelRect = this.labels[this.index].getBoundingClientRect();
          const rect = scroller.getBoundingClientRect();
          if (labelRect.left < rect.left + 16 || labelRect.right > rect.right - 16) {
            scroller.scrollTo({ left: scroller.scrollLeft + labelRect.left - rect.left - (rect.width - labelRect.width) / 2, behavior: reduced ? 'auto' : 'smooth' });
          }
        }
      }
    }

    scheduleNavigationMeasure() {
      if (this._measureFrame) return;
      this._measureFrame = requestAnimationFrame(() => {
        this._measureFrame = 0;
        if (this._abort) this.measureNavigation();
      });
    }

    measureNavigation() {
      if (this.dataset.labelLayout === 'double' && this.labels.length) {
        this.style.setProperty('--hrs-nav-title-height','0px');
        this.style.setProperty('--hrs-nav-subtitle-height','0px');
        const height = Math.max(0,...this.titleNodes.map(title => title.getBoundingClientRect().height));
        const subtitleHeight = Math.max(0,...this.subtitleNodes.map(subtitle => subtitle.getBoundingClientRect().height));
        this.style.setProperty('--hrs-nav-title-height',height + 'px');
        this.style.setProperty('--hrs-nav-subtitle-height',subtitleHeight + 'px');
      }
      if (this.labelsArea && this.labels.length) {
        const height = Math.max(44,...this.labels.map(label => label.offsetHeight));
        if (this.labelsArea.style.height !== height + 'px') this.labelsArea.style.height = height + 'px';
      }
      if (!this.tabList) return;
      const rect = this.tabList.getBoundingClientRect();
      const underline = this.dataset.labelStyle === 'underline';
      this.indicatorPositions = this.labels.map(node => {
        const label = node.getBoundingClientRect();
        const width = underline ? Math.max(24,Math.min(84,label.width - 32)) : label.width;
        return {
          left: label.left - rect.left - this.tabList.clientLeft + (label.width - width) / 2,
          top: (underline ? label.bottom + 1 : label.top) - rect.top - this.tabList.clientTop,
          width,
          height: underline ? 3 : label.height
        };
      });
      this.updateTabIndicator();
    }

    updateTabIndicator() {
      const position = this.indicatorPositions?.[this.index];
      if (!this.tabList || !position) return;
      for (const key of ['left','top','width','height']) this.tabList.style.setProperty('--hrs-indicator-' + key,position[key] + 'px');
    }

    disconnectedCallback() {
      if (this._waiting) document.removeEventListener('DOMContentLoaded',this._waiting);
      this._waiting = null;
      if (this._abort) this._abort.abort();
      this._resize?.disconnect();
      this._resize = null;
      if (this._measureFrame) cancelAnimationFrame(this._measureFrame);
      this._measureFrame = 0;
      this.slider?.removeAttribute('data-dragging');
      this.sliderPointerId = this.pointerId = null;
      this._abort = null;
      this.removeAttribute('data-ready');
    }
  }

  customElements.define(tag,HaloralRltSliderV6);
})();

  } catch(e) { console.error(e); }
})();
})();
